import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "__row" };
const _hoisted_2 = {
    class: "__column",
    style: { "flex": "0 0 auto" }
};
const _hoisted_3 = { class: "icons__search" };
const _hoisted_4 = {
    class: "__column",
    style: { "padding-left": "10px" }
};
const _hoisted_5 = ["value", "placeholder"];
import CoreService from "@/services/core.service";
import { Search } from 'lucide-vue-next';
import { Views } from "@/types/ConfigTypes";
import { onMounted, ref } from "vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'SearchInputField',
    props: {
        autoFocus: {
            type: Boolean,
            default: false
        },
        defaultValue: {
            type: String,
            default: ''
        },
        // whether the search result page should push a new history entry like (router.push or router.replace)
        pushNavigation: {
            type: Boolean,
            default: false
        }
    },
    emits: ['change', 'update'],
    setup(__props, { emit: emits }) {
        const props = __props;
        let timeoutID = null;
        const headerInputField = ref(null);
        const keyUp = (e) => {
            clearTimeout(timeoutID);
            emits('change', e.target.value);
            timeoutID = setTimeout(() => {
                emits('update', e.target.value);
                if (props.pushNavigation) {
                    CoreService.push(Views.HELPCENTER, { query: e.target.value });
                }
                else {
                    CoreService.replace(Views.HELPCENTER, { query: e.target.value });
                }
            }, 500);
        };
        onMounted(() => {
            if (props.autoFocus) {
                headerInputField.value.focus();
            }
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createVNode(_unref(Search), { size: "16" })
                    ])
                ]),
                _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("input", {
                        type: "text",
                        id: "headerInputField",
                        ref_key: "headerInputField",
                        ref: headerInputField,
                        name: "search",
                        "aria-label": "search",
                        value: __props.defaultValue,
                        placeholder: _ctx.$t('search.input_placeholder'),
                        onKeyup: keyUp
                    }, null, 40, _hoisted_5)
                ])
            ]));
        };
    }
});
